const VuePlugin = {
  install: function(Vue, options) {
    Vue.prototype.$t = function(key, ...args) {
      if (args) {
        return window.i18n.t(key, ...args);
      } else {
        return window.i18n.t(key);
      }
    };
    Vue.prototype.$getMonths = function(key) {
      return window.i18n.getMonths();
    };
    Vue.prototype.$getWeekdays = function(key) {
      return window.i18n.getWeekdays();
    };
  }
};

export default { VuePlugin };



// WEBPACK FOOTER //
// ./src/js/i18n.js